// UnlimitedTypes
export const UNLIMITED_INTRO_TYPE = 1;
export const UNLIMITED_EXISTING_TYPE = 2;
